<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <separater-line/>
    <v-layout
      class="text-xs-center pt-2"
      justify-space-around
      row>
      <v-flex
        v-if="showRowsSelector"
        class="leftMargin"
        lg2
        hidden-md-and-down/>
      <v-flex
        lg8
        md12
        class="centerElement"
      >
        <v-list
          v-if="(pageCount > 1)" 
          class="v-pagination theme--light">
          <v-list-tile v-if="selectedPage > 1">
            <v-btn
              class="v-pagination__navigation icon"
              @click="$emit('clickedPage', 1)">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-chevron-double-left"/>
            </v-btn>
          </v-list-tile>
          <v-list-tile v-if="selectedPage > 1">
            <v-btn
              class="v-pagination__navigation icon"
              @click="$emit('clickedPage', selectedPage-1)">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-chevron-left"/>
            </v-btn>
          </v-list-tile>

          <v-list-tile 
            v-for="item in getPageButtons()" 
            :key="item">
            <v-btn
              :color="item === selectedPage ? 'warning':'primary'"
              class="v-pagination__item"
              @click="$emit('clickedPage', item)">{{ item }}</v-btn>
          </v-list-tile>

          <v-list-tile v-if="selectedPage < pageCount">
            <v-btn
              class="v-pagination__navigation icon"
              @click="$emit('clickedPage', selectedPage+1)">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-chevron-right"/>
            </v-btn>
          </v-list-tile>
          <v-list-tile v-if="selectedPage < pageCount">
            <v-btn
              class="v-pagination__navigation icon"
              @click="$emit('clickedPage', pageCount)">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-chevron-double-right"/>
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex
        v-if="showRowsSelector"
        class="rightMargin"
        lg2
        hidden-md-and-down>
        <v-layout >
          <v-flex
            ref="total"
            class="disablePadding"
            align-self-center
            md6>
            <span
              class="darkText">{{ totalItems }}</span>
          </v-flex>
          <v-flex 
            md6 
            class="disablePadding">
            <v-select
              v-model="rowsCountSelection"
              :items="getRowCount ()"
              @change="changeDisplayedRowCount">
              <template v-slot:item="data">
                <v-list-tile-content
                  class="darkText"
                  v-text="data.item"/>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>



<script>
import SeparaterLine from "./SeparaterLine";

  //posilame pocet stranek a selected stranku, zpatky vraci selected stranku po kliknuti
  //pokud bude stranek vic nez x, ukazuje x...x
  //sipky pro skok na zacatek a skok na konec

export default {
    name: 'Pagination',
  components: {SeparaterLine},
  // eslint-disable-next-line vue/require-prop-types
    props: ['selectedPage','rowsPerPage', 'rowCount'],
    data ()
    {
        return {
            dialog: false,
            rowsCountSelection: ['5'],
            mdScreenSizePlusDrawer: false,
            showRowsSelectorBoolean: true
        }
    },
    computed: {
      pageCount ()
      {
        if (this.rowCount == null || this.rowsPerPage == null)
        {
          return 0
        }
        return Math.ceil(this.rowCount/this.rowsPerPage)
      },
      totalItems ()
      {
        let self = this;
        if (self.rowsPerPage === -1) {
          return self.rowCount + ' of ' + self.rowCount
        }
        else {
          let currentItems =  (self.selectedPage*self.rowsPerPage > self.rowCount) ? self.rowCount : self.selectedPage*self.rowsPerPage;
          return currentItems + ' of ' + self.rowCount
        }
      },
      showRowsSelector ()
      {
        let self = this;

        return self.rowCount >= 5;
      },
    },
  mounted () {
      let self = this;

      self.getRowCountSelectionOnMount();

  },
    methods: {
      getRowCountSelectionOnMount ()
      {
        let self = this;

        self.rowsCountSelection = '5';
      },
      getRowCount ()
      {
        return ['5','15','50',this.$t('krita.common.all')]
      },
      getPageButtons ()
      {
        let self = this;

        let pages = [];
        if (self.pageCount > 7) // if pageCount is more than 7
        {
          if (self.selectedPage >= 4)
          {
            //generate buttons that are three pages up and down
            for (let i = (self.selectedPage - 3); (i <= self.pageCount) && (i <= self.selectedPage+3); i++)
            {
              pages.push(i);
            }

          }
          else
          {
            //get 7 buttons form start
            for (let i = 1; (i <= self.pageCount) && (i <= 7); i++)
            {
              pages.push(i);
            }
          }
        }
        else
        {
          return self.pageCount;
        }
        return pages;
      },
      changeDisplayedRowCount ()
      {
        let self = this;

        self.$emit('changeDisplayedRowCount', self.rowsCountSelection)
      },
      addDisplayedRowCountValue (e)
      {
        let self= this;

        if(e.target.value === 0 || e.target.value === undefined || isNaN(e.target.value))
        {
          return;
        }
        self.rowsCount.push(e.target.value);

        self.rowsCountSelection = e.target.value;
        self.changeDisplayedRowCount ();
      }
    }
}
</script>

<style lang="scss" scoped>
  button.v-pagination__navigation.icon{
    padding: 0px;
    min-width: 0;
  }
  .darkText{
    color: darken(white,48);
    font-size: 14px;
    font-weight: lighter;
  }
  .rightMargin{
    margin-right: 25px;
  }
  .leftMargin{
    margin-left: 25px;
  }
  .centerElement{
    flex-flow: row wrap;
  }
  .disablePadding{
    padding: 0 !important;
  }
</style>
